import React, { memo } from 'react';

function IconSchedule({ color = "white", ...props }) {
    return (
        <svg {...props} width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 0.75V2.75M6 4.25V2.75M12.5 0.75V2.75M12.5 4.25V2.75M6 2.75H3C1.89543 2.75 1 3.64543 1 4.75V15.25C1 16.3546 1.89543 17.25 3 17.25H15.5C16.6046 17.25 17.5 16.3546 17.5 15.25V4.75C17.5 3.64543 16.6046 2.75 15.5 2.75H12.5M6 2.75H12.5M1 7.75H17.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default memo(IconSchedule);